<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-content">

    <div class="cp-header">
      <div class="cp-label">
        {{ 'warranty_extension' | translate }}
      </div>
      <div class="cp-button" (click)="close()">
        <img src="assets/img/ic-close.png"/>
      </div>
    </div>

    <div class="content">
      <div class="cp-title">
        {{ 'upload_document_title' | translate }}
      </div>
      <div class="cp-subtitle">
        {{ 'upload_document_subtitle' | translate }}
      </div>
      <div class="cp-subtitle">
        {{ 'upload_document_formats' | translate }}
      </div>

      @if (!selectedFile) {
      <div class="cp-upload-box" [class]="{'cp-error': submitted && !selectedFile}"
        (drop)="onDropped($event)" (dragover)="$event.preventDefault()" (dragenter)="$event.preventDefault()">
        <img src="/assets/img/ic-upload.png">
        <div class="cp-drag-label">
          {{ 'upload_document_drag_here' | translate }}
        </div>
        <input #fileInput type="file" [multiple]="false" [accept]="allowedTypes" (change)="onSelected($event)">
        <div class="cp-click-label" (click)="fileInput.click()">
          {{ 'upload_document_select' | translate }}
        </div>
      </div>
      }

      @if (selectedFile) {
      <div class="cp-file-box">
        <div class="cp-file-box-name">
          {{ selectedFile.name }}
        </div>
        <div class="cp-button" (click)="clearFile()">
          <img src="assets/img/ic-close.png"/>
        </div>
      </div>
      }

      <form [formGroup]="form">
        <div class="cp-field cp-p-top-20">
          <label class="cp-label">
            {{ 'documents_date' | translate }}
          </label>
          <div class="cp-control" [class]="{'error': submitted && !form.get('date')?.valid}">
            <input class="cp-input" type="date" formControlName="date">
          </div>
        </div>

        <div class="cp-field cp-p-top-20">
          <div class="cp-check-control">
            <div>
              <input type="checkbox" formControlName="check">
              @if (!form.get('check')?.value) {
              <img src="/assets/img/unchecked.png"> 
              }
              @else {
              <img src="/assets/img/checked.png"> 
              }
            </div>
            <div [class]="{'text-error': submitted && !form.get('check')?.valid}">
              {{ 'upload_document_disclaimer' | translate }}
            </div>  
          </div>
        </div>
      </form>

    </div>

    <div class="cp-footer">
      <button class="coupon-button gray" (click)="close()">
        {{ 'cancel' | translate | uppercase }}
      </button>
      <button class="coupon-button" (click)="upload()">
        {{ 'upload_document' | translate | uppercase }}
      </button>
    </div>

    @if (loading()) {
    <div class="cp-loading-content">
      <img class="cp-img rotating" src="/assets/img/ic-warranty-loading.png">

      <div class="cp-subtitle cp-m-top-20">
        {{ 'warranty_ok_waiting' | translate }}
      </div>
    </div>
    }

  </div>
</div>
